import Immutable from 'immutable'
import * as JsSearch from 'js-search'
import localStorage from '../../lib/localStorage'

export const GET_LOCATIONS = 'takeback/api/GET_LOCATIONS';
export const GET_LOCATIONS_SUCCESS = 'takeback/api/GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_FAILURE = 'takeback/api/GET_LOCATIONS_FAILURE';

export const GET_LOCATIONS_COUNT = 'takeback/api/GET_LOCATIONS_COUNT';
export const GET_LOCATIONS_COUNT_SUCCESS = 'takeback/api/GET_LOCATIONS_COUNT_SUCCESS';
export const GET_LOCATIONS_COUNT_FAILURE = 'takeback/api/GET_LOCATIONS_COUNT_FAILURE';

export const GET_RECENT_LOCATIONS = 'takeback/api/GET_RECENT_LOCATIONS';
export const GET_RECENT_LOCATIONS_SUCCESS = 'takeback/api/GET_RECENT_LOCATIONS_SUCCESS';
export const GET_RECENT_LOCATIONS_FAILURE = 'takeback/api/GET_RECENT_LOCATIONS_FAILURE';

export const SEARCH_LOCATIONS = 'takeback/locations/SEARCH';
export const RESET_FILTER = 'takeback/locations/RESET_FILTER';

export const FAVORITE_LOCATION = 'takeback/locations/FAVORITE';
export const UNFAVORITE_LOCATION = 'takeback/locations/UNFAVORITE';

export const CREATE_LOCATION_SUBMIT = 'takeback/locations/CREATE_LOCATION_SUBMIT';
export const CREATE_LOCATION_SUCCESS = 'takeback/locations/CREATE_LOCATION_SUCCESS';
export const CREATE_LOCATION_FAILURE = 'takeback/locations/CREATE_LOCATION_FAILURE';

export const UPDATE_LOCATION_SUBMIT = 'takeback/locations/UPDATE_LOCATION_SUBMIT';
export const UPDATE_LOCATION_SUCCESS = 'takeback/locations/UPDATE_LOCATION_SUCCESS';
export const UPDATE_LOCATION_FAILURE = 'takeback/locations/UPDATE_LOCATION_FAILURE';

export const HIDE_LOCATION_SUBMIT = 'takeback/locations/HIDE_LOCATION_SUBMIT';
export const HIDE_LOCATION_SUCCESS = 'takeback/locations/HIDE_LOCATION_SUCCESS';
export const HIDE_LOCATION_FAILURE = 'takeback/locations/HIDE_LOCATION_FAILURE';

export const SET_SEARCH_RESULTS = 'takeback/locations/SET_SEARCH_RESULTS';
export const CLEAR_SEARCH_RESULTS = 'takeback/locations/CLEAR_SEARCH_RESULTS';

export const SEARCH_LOCATIONS_BY_NUMBER = 'takeback/api/SEARCH_LOCATIONS_BY_NUMBER';
export const SEARCH_LOCATIONS_BY_NUMBER_SUCCESS = 'takeback/api/SEARCH_LOCATIONS_BY_NUMBER_SUCCESS';
export const SEARCH_LOCATIONS_BY_NUMBER_FAILURE = 'takeback/api/SEARCH_LOCATIONS_BY_NUMBER_FAILURE';

const initialState = Immutable.Map({
    // A map of all locations, indexed by id
    list: Immutable.Map(),

    // A list of ids
    filtered: Immutable.Set(),

    // TODO: Is this the right place?
    favorites: Immutable.Set(localStorage.get('locations.favorites')),

    // The current filter
    filter: null,

    count: null,

    // Recent locations state
    recentLocations: Immutable.List(),
    recentPagination: null,
    loadingRecent: false,

    // Search results state
    searchResults: Immutable.List(),
    searchTerm: '',
    isSearching: false
});

const search = new JsSearch.Search('id');
search.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();


search.tokenizer = {
    tokenize(text) {
        // This is needed to index umlauts and other non latin characters
        return text
            .split(/[^a-zA-Z\x7f-\xff0-9\-']+/)
            .filter(str => !!str);
    },
};

search.addIndex(['address', 'city']);
search.addIndex(['address', 'email']);
search.addIndex(['address', 'organization']);
search.addIndex(['address', 'street']);
search.addIndex(['address', 'unit']);
search.addIndex(['number']);
search.addIndex(['info']);
search.addIndex(['oldNumber']);

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GET_LOCATIONS_SUCCESS: {
        search.addDocuments(action.locations.toList().toJS());
        return state.set('list', state.get('list').mergeDeep(action.locations.reduce((map, location) => {
            return map.set(location.get('id'), location);
        }, Immutable.Map())));
    }

    case GET_LOCATIONS_COUNT_SUCCESS: {
        return state.set('count', action.count);
    }

    case GET_RECENT_LOCATIONS: {
        return state.set('loadingRecent', true);
    }

    case GET_RECENT_LOCATIONS_SUCCESS: {
        const locations = action.locations;
        const pagination = action.pagination;
        
        // Add to search index
        search.addDocuments(locations.toList().toJS());
        
        // Add to main locations list
        const newList = state.get('list').mergeDeep(locations.reduce((map, location) => {
            return map.set(location.get('id'), location);
        }, Immutable.Map()));
        
        // Update recent locations list
        const append = action.append || false;
        const recentList = append 
            ? state.get('recentLocations').concat(locations.toList())
            : locations.toList();
        
        return state
            .set('list', newList)
            .set('recentLocations', recentList)
            .set('recentPagination', pagination)
            .set('loadingRecent', false);
    }

    case GET_RECENT_LOCATIONS_FAILURE: {
        return state.set('loadingRecent', false);
    }

    case RESET_FILTER: {
        return state
            .set('filter', null)
            .set('filtered', Immutable.Set());
    }

    case CREATE_LOCATION_SUCCESS: {
        const location = action.payload;
        search.addDocuments([location.toJS()]);
        return state.update('list', list => (
            list.set(location.get('id'), location)
        ));
    }

    case UPDATE_LOCATION_SUCCESS: {
        const location = action.payload;
        search.addDocuments([location.toJS()]);
        return state.update('list', list => (
            list.set(location.get('id'), location)
        ));
    }

    case SEARCH_LOCATIONS: {
        const results = search.search(action.term);
        return state
            .set('filter', action.term)
            .set('filtered', Immutable.Set(results.map(location => location.id)));
    }

    case FAVORITE_LOCATION: {
        // We only allow a single favorite location right now
        const result = state.update('favorites', list => list.clear().add(action.id));
        localStorage.set('locations.favorites', result.get('favorites').toJS());
        return result;
    }

    case UNFAVORITE_LOCATION: {
        // We only allow a single favorite location right now
        const result = state.update('favorites', list => list.clear());
        localStorage.set('locations.favorites', result.get('favorites').toJS());
        return result;
    }

    case SET_SEARCH_RESULTS: {
        return state
            .set('searchResults', Immutable.fromJS(action.searchResults))
            .set('searchTerm', action.searchTerm);
    }

    case CLEAR_SEARCH_RESULTS: {
        return state
            .set('searchResults', Immutable.List())
            .set('searchTerm', '')
            .set('isSearching', false);
    }

    case SEARCH_LOCATIONS_BY_NUMBER: {
        return state.set('isSearching', true);
    }

    case SEARCH_LOCATIONS_BY_NUMBER_SUCCESS: {
        const locations = action.locations;
        
        // Add to main locations list
        const newList = state.get('list').mergeDeep(locations.reduce((map, location) => {
            return map.set(location.get('id'), location);
        }, Immutable.Map()));
        
        return state
            .set('list', newList)
            .set('searchResults', locations)
            .set('searchTerm', action.searchTerm)
            .set('isSearching', false);
    }

    case SEARCH_LOCATIONS_BY_NUMBER_FAILURE: {
        return state
            .set('searchResults', Immutable.List())
            .set('isSearching', false);
    }

    default: return state;
    }
}

// Selectors
export function selectLocations(state) {
    return state.locations.get('list');
}

export function selectLocationFilter(state) {
    return state.locations.get('filter');
}

export function selectFavorites(state) {
    return state.locations.get('favorites');
}

export function isFavorite(state, locationId) {
    return state.locations.get('favorites').contains(locationId);
}

export function selectFavoriteLocations(state) {
    return state.locations.get('favorites').map(id => (
        state.locations.get(['list', parseInt(id, 10)])
    ));
}

// TODO: Rewrite this as a proper reselect selector
export function selectFilteredLocations(state, returnAllOnEmptyFilter = true) {
    if (returnAllOnEmptyFilter && !state.locations.get('filter')) {
        return selectLocations(state);
    }
    return state.locations.get('filtered').reduce((result, id) => {
        return result.set(id, state.locations.getIn(['list', id]));
    }, Immutable.Map());
}

export function selectLocation(state, location) {
    return state.locations.getIn(['list', parseInt(location, 10)]);
}

export function selectRecentLocations(state) {
    return state.locations.get('recentLocations');
}

export function selectRecentPagination(state) {
    return state.locations.get('recentPagination');
}

export function selectLoadingRecent(state) {
    return state.locations.get('loadingRecent');
}

export function selectSearchResults(state) {
    return state.locations.get('searchResults');
}

export function selectSearchTerm(state) {
    return state.locations.get('searchTerm');
}

export function selectIsSearching(state) {
    return state.locations.get('isSearching');
}

// Actions
export function resetFilter() {
    return { type: RESET_FILTER };
}

export function favoriteLocation(id) {
    return { type: FAVORITE_LOCATION, id };
}

export function unfavoriteLocation(id) {
    return { type: UNFAVORITE_LOCATION, id };
}

export function searchLocations(term) {
    return { type: SEARCH_LOCATIONS, term };
}

export function getLocations(params = {}, options = {}) {
    return Object.assign({ type: GET_LOCATIONS, params }, options);
}

export function getLocationsSuccess(locations) {
    return { type: GET_LOCATIONS_SUCCESS, locations };
}

export function getLocationsFailure(error) {
    return { type: GET_LOCATIONS_FAILURE, error };
}

export function getLocationsCount(params = {}, options = {}) {
    return Object.assign({ type: GET_LOCATIONS_COUNT, params }, options);
}

export function getLocationsCountSuccess(count) {
    return { type: GET_LOCATIONS_COUNT_SUCCESS, count };
}

export function getLocationsCountFailure(error) {
    return { type: GET_LOCATIONS_COUNT_FAILURE, error };
}

export function getRecentLocations(params = {}, options = {}) {
    return Object.assign({ type: GET_RECENT_LOCATIONS, params }, options);
}

export function getRecentLocationsSuccess(data, append = false) {
    let locations, pagination;
    
    // Handle paginated response structure
    if (data.locations && data.pagination) {
        locations = data.locations;
        pagination = data.pagination;
    } else {
        // Handle legacy response structure
        locations = data;
        pagination = null;
    }
    
    return { type: GET_RECENT_LOCATIONS_SUCCESS, locations, pagination, append };
}

export function getRecentLocationsFailure(error) {
    return { type: GET_RECENT_LOCATIONS_FAILURE, error };
}

export function hideLocation(id) {
    return { type: HIDE_LOCATION_SUBMIT, id };
}

export function setSearchResults(searchResults, searchTerm) {
    return { type: SET_SEARCH_RESULTS, searchResults, searchTerm };
}

export function clearSearchResults() {
    return { type: CLEAR_SEARCH_RESULTS };
}

export function searchLocationsByNumber(searchTerm, options = {}) {
    return Object.assign({ type: SEARCH_LOCATIONS_BY_NUMBER, searchTerm }, options);
}

export function searchLocationsByNumberSuccess(locations, searchTerm) {
    return { type: SEARCH_LOCATIONS_BY_NUMBER_SUCCESS, locations, searchTerm };
}

export function searchLocationsByNumberFailure(error) {
    return { type: SEARCH_LOCATIONS_BY_NUMBER_FAILURE, error };
}

